module.exports = "/_next/static/images/digitalbanking-line-9c6fc9da3fbb84799a83c53283d0dcdf.svg";